import React, { useState } from "react";
import Comments from "../Comments";
import { toast } from "react-hot-toast";
import api from "../../services/api";

const FollowUp = ({ user, setUser }) => {
  return (
    <div className="bg-white border-[1px] rounded-lg border-gray-200 p-4">
      <div className="mb-4">
        <div className="flex items-center justify-between mb-4">
          <p className="font-medium">Comments</p>
        </div>

        <Comments
          value={user.follow_up_comments}
          onAdd={async (text) => {
            const { data } = await api.post(`/user/${user._id}/follow-up-comment`, { text });
            setUser(data);
            toast.success("Comment added!");
          }}
        />
      </div>
    </div>
  );
};

export default FollowUp;
